<template>
    <div v-bind:class="[activenav?'active':'' , 'hi'] " id="navbar">
        <nav class="navbar navbar-expand-lg navbar-light bg-light p-4">
            <div class="container">
                <a class="navbar-brand" href="/">
                    <h2>
                        SPAC<span>DYNA</span>
                    </h2>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse   navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item">
                            <a class="nav-link active ad" @click="activate('ad')" aria-current="page" href="#">Home</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link abdoutus" @click="activate('abdoutus')" href="#abdoutus">About Us</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link serves" @click="activate('serves')" href="#serves">Services</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link Portfolio" @click="activate('Portfolio')" href="#portfolio">Portfolio</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link blog" @click="activate('blog')" href="#blog">Blog</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link contact" @click="activate('contact')" href="#contact">Message Us</a>
                        </li>
                    </ul>
                    <div class="area-button">
                        <button>Contact Now</button>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import { doc } from 'prettier';


    export default {
    name: "navbar",
    data() {
        return {
            activenav: false,
        }
    },
    created() {
        
        let x = this; 
        setTimeout(() => {
            x.activenav = true; 
        }, 500);
    },
    methods:{
        activate(x){
            let a = document.querySelectorAll(".nav-link")
            a.forEach((one)=>{
                one.classList.remove("active");
            });
            let b = document.querySelector(`.${x}`)
            console.log(b)
            b.classList.add("active");
        }
    }
    }
</script>

<style  scoped>
.hi{
position: fixed;
    top: -100px;
    transition: all .9s;
    width:100%;
    z-index: 100;
}
.navbar{
    background-color: white !important;
    
}
.hi.active{
    top:0px
}
.area-button {
    width: 25%;
}
.area-button button{
    border:none;
    background-color: #fe3f40;
    color:white;
    padding:10px 20px;
    border-radius: 19px;
    transition: all .9s;
}
.area-button button:hover {
    background-color:#03a4ed;
}
.nav-link{
    color:#2a2a2a !important;
    font-size: 15px;
    font-weight: 400;
    transition: all .9s;
}
.nav-link.active ,
.nav-link:hover{
    color:#fe3f40 !important;
}
.navbar-nav {
    width: 60%;
    justify-content: space-between;
}
.navbar-brand h2{
    color:#03a4ed;
    font-size: 25px;
    font-weight: 600;
}
.navbar-brand h2 span{
    color:#fe3f40;
}
</style>